module.exports = __webpack_public_path__ + "static/img/result2.cc861bf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/showcase/xi/challenge/result2.png
// module id = gwVI
// module chunks = 1